// MSDYN links variant dimensions to a numeric value called dimensionTypeValue.

export const DIMENSION_TYPE_VALUES = {
    COLOR: 1,
    SIZE: 3
} as const;
